<template>
  <md-card>
    <md-card-header>
      <h4>Filtrar</h4>
    </md-card-header>

    <md-card-content>
      <div
        class="md-layout-item md-layout md-medium-size-33 md-small-size-33 md-xsmall-size-100 md-gutter"
      >
        <div class="md-layout-item md-layout md-size-33">
          <md-field>
            <label>Autopista</label>
            <md-select v-model="highway">
              <md-option
                v-for="option in highways"
                :key="option.id"
                :value="option.id"
              >{{ option.name }}</md-option>
            </md-select>
          </md-field>
        </div>

        <div class="md-layout-item md-layout md-size-33">
          <md-field>
            <label>
              <md-icon>calendar_today</md-icon>Desde
            </label>
            <datetime
              data-vv-name="fromDate"
              input-style="border: none; outline:none; width: 100%"
              type="date"
              input-class="Object"
              title="Desde"
              value-zone="America/Mexico_City"
              v-model="fromDate"
              :phrases="{ ok: '', cancel: '' }"
              auto
            ></datetime>
            <md-button class="md-info md-simple md-just-icon" @click="fromDate = ''">
              <md-icon>close</md-icon>
            </md-button>
          </md-field>
        </div>

        <div class="md-layout-item md-layout md-size-33">
          <md-field>
            <label>
              <md-icon>calendar_today</md-icon>Hasta
            </label>
            <datetime
              data-vv-name="toDate"
              input-style="border: none; outline:none; width: 100%"
              type="date"
              input-class="Object"
              title="Hasta"
              value-zone="America/Mexico_City"
              v-model="toDate"
              :phrases="{ ok: '', cancel: '' }"
              auto
            ></datetime>
            <md-button class="md-info md-simple md-just-icon" @click="toDate = ''">
              <md-icon>close</md-icon>
            </md-button>
          </md-field>
        </div>
      </div>
    </md-card-content>
  </md-card>
</template>

<script>
import moment from "moment";
import catalogService from "@/services/catalog";

export default {
  name: "FilterSinisters",
  data() {
    return {
      highways: [],
      highway: null,
      fromDate: moment().subtract(15, "days").format("YYYY-MM-DD"),
      toDate: moment().format("YYYY-MM-DD"),
    };
  },
  mounted() {
    catalogService.fetch("highway").then((response) => {
      this.highways = response;
    });
  },
  methods: {
    change() {
      this.$emit("change", {
        highway: this.highway,
        from: this.fromDate,
        to: this.toDate,
      });
    },
  },
  watch: {
    highway(value) {
      this.change();
    },
    fromDate(value) {
      this.change();
    },
    toDate(value) {
      this.change();
    },
  },
};
</script>

<style lang="scss" scoped>
.md-card-content:last-of-type {
  padding-bottom: 0px;
}

.md-card .md-card-content {
  padding: 0px 15px;
  line-height: 1.75em;
  position: relative;
}

.md-field.md-focused label,
.md-field.md-has-value label,
.md-field.md-focused.md-has-value label {
  color: #6d6d6dab !important;
  font-weight: bold;
  font-size: 1.4rem;
}

.md-field.md-focused label,
.md-field.md-field.md-has-value label {
  top: -1rem;
}

.vdatetime {
  margin-left: 2em;
  margin-top: 1.1em;
  width: 100%;
}

.date-label {
  top: -9px;
}

.md-field label {
  top: 1px;
}

.md-button.reload-button .md-button-content i {
  font-size: 32px !important;
}

.rotating {
  transition: transform 1s ease-in-out;
  transform: rotateZ(360deg);
}

.md-field.md-valid .vdatetime {
  color: #4caf50 !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/extranet/FilterSinisters.vue